// Business areas and schemas are addressed by name in page URLs (/businessareas/:businessarea/
// schemas/:schema/...). A link built from ids alone still works: the id is resolved and the page
// moves to the name-based URL.

// A business area or schema id: a 17-digit timestamp and 32 hex characters.
const ENTITY_ID = /^\d{17}[0-9a-f]{32}$/i;

export const isEntityId = (value) => typeof value === "string" && ENTITY_ID.test(value);

// The path with one segment after `/<collection>/` replaced (only that whole segment); names go
// into the path as they are, as everywhere else that builds these URLs.
export const replacePathSegment = (pathname, collection, from, to) => {
    const escaped = from.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    return pathname.replace(new RegExp(`(/${collection}/)${escaped}(?=/|$)`, "i"), `$1${to}`);
};

// What to show when the business area (or schema) of a page could not be loaded: "notFound",
// "denied" or "failed" (anything else, which a retry may fix).
export const loadFailureKind = (result) => {
    if (!result || result.success !== false) {
        return null;
    }
    if (result.code === "NOT_FOUND_ERROR") {
        return "notFound";
    }
    if (result.code === "PERMISSION_DENIED") {
        return "denied";
    }
    return "failed";
};
